// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"iE","delete_item":"jE","subscription_item":"kE","subscription_item_img_wrapper":"lE","subscription_item_info":"mE","subscription_item_title":"nE","subscription_item_edit":"oE","subscription_item_wrapper":"pE","arrow":"qE","subscription_item_category":"rE","plus_button":"sE","more_details":"tE","old_price":"uE","discount":"vE"};
    if(module.hot) {
      // 1738836196801
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  